const spacingScale = {
  DESKTOP_HD: {
    X_LARGE: 132,
    LARGE: 66,
    MEDIUM: 33,
    SMALL: 22,
    X_SMALL: 16,
  },

  DESKTOP: {
    X_LARGE: 120,
    LARGE: 60,
    MEDIUM: 30,
    SMALL: 20,
    X_SMALL: 15,
  },

  MOBILE: {
    X_LARGE: 108,
    LARGE: 54,
    MEDIUM: 27,
    SMALL: 18,
    X_SMALL: 13,
  },

  FOOTER: {
    LARGE: 647,
    MOBILE: 550,
  },
};

export default {
  ...spacingScale,

  MOBILE_X: spacingScale.MOBILE.MEDIUM,
  MOBILE_Y: spacingScale.MOBILE.LARGE,
  MOBILE_X_LARGE: spacingScale.MOBILE.X_LARGE,
  MOBILE_Y_SMALL: spacingScale.MOBILE.SMALL,

  DESKTOP_X: spacingScale.DESKTOP.LARGE,
  DESKTOP_Y: spacingScale.DESKTOP.X_LARGE,

  DESKTOP_HD_X: spacingScale.DESKTOP_HD.X_LARGE,
  DESKTOP_HD_Y: spacingScale.DESKTOP_HD.X_LARGE,
  DESKTOP_HD_X_XS: spacingScale.DESKTOP_HD.X_SMALL,
  DESKTOP_HD_Y_XS: spacingScale.DESKTOP_HD.X_SMALL,

  FOOTER_X_LARGE: spacingScale.FOOTER.LARGE,
  FOOTER_X_S: spacingScale.FOOTER.MOBILE,
};



// WEBPACK FOOTER //
// ./src/identity/spacingScale.js